// Note: The first file of a module here, must also register the module

import "./chart.helper";
import "./data-chart.component";
import "./data-stats.component";
import "./data-table.component";
import "./result-export.component";
import "./survey-result-page.component";
import "./user-performance-data-table.component";
